module.exports = __webpack_public_path__ + "everybody_logo-580afdee9903294f5a8434ed06987021.png";